import { privateAxios } from "@/common/api/axios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

export type UseEstablishmentAllowedProductsProps<T> = {
  filters?: {
    search?: string
    page?: number
    categoryId?: string
    establishmentId?: string
  }
  enabled?: boolean,
  mapper?: (data: any) => T,
}

export const useEstablishmentAllowedProducts = <T,>({
  filters: { search = '', page, categoryId, establishmentId } = {},
  mapper = Mapper.default<T>(),
  enabled
}: UseEstablishmentAllowedProductsProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['establishmentAllowedProducts', establishmentId, search, page, categoryId],
    queryFn: () => {
      return privateAxios.get(`/establishment/companies/${establishmentId}/allowed_products`, {
        params: {
          search,
          page,
          'q[category_id_eq]': categoryId,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
    enabled: enabled
  })

  return { data, meta, isPending, ...rest }
}
